var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveAddon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "#F8F9FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 20.5H17.75C17.875 20.5 18 20.4062 18 20.25V11.75C18 11.625 17.875 11.5 17.75 11.5H17.25C17.0938 11.5 17 11.625 17 11.75V20.25C17 20.4062 17.0938 20.5 17.25 20.5ZM12.25 20.5H12.75C12.875 20.5 13 20.4062 13 20.25V11.75C13 11.625 12.875 11.5 12.75 11.5H12.25C12.0938 11.5 12 11.625 12 11.75V20.25C12 20.4062 12.0938 20.5 12.25 20.5ZM21.75 9H18.5L17.4375 7.625C17.1875 7.28125 16.6562 7 16.25 7H13.75C13.3125 7 12.7812 7.28125 12.5312 7.625L11.5 9H8.25C8.09375 9 8 9.125 8 9.25V9.75C8 9.90625 8.09375 10 8.25 10H9V21.5C9 22.3438 9.65625 23 10.5 23H19.5C20.3125 23 21 22.3438 21 21.5V10H21.75C21.875 10 22 9.90625 22 9.75V9.25C22 9.125 21.875 9 21.75 9ZM13.3438 8.21875C13.4062 8.09375 13.5938 8.03125 13.75 8H16.25C16.375 8.03125 16.5625 8.09375 16.625 8.21875L17.25 9H12.75L13.3438 8.21875ZM20 21.5C20 21.7812 19.75 22 19.5 22H10.5C10.2188 22 10 21.7812 10 21.5V10H20V21.5ZM14.75 20.5H15.25C15.375 20.5 15.5 20.4062 15.5 20.25V11.75C15.5 11.625 15.375 11.5 15.25 11.5H14.75C14.5938 11.5 14.5 11.625 14.5 11.75V20.25C14.5 20.4062 14.5938 20.5 14.75 20.5Z",
    fill: "#DC3545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveAddon);
export default __webpack_public_path__ + "static/media/remove-addon.c854fb43.svg";
export { ForwardRef as ReactComponent };